import ComponentInit from './utils/ComponentInit';
import ArticleListing from '4-sections/ArticleListing/ArticleListing';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { ArticleListing };

export default ComponentInit(componentList);
